import React from 'react';
import { User } from '../../types';

interface UserAvatarProps {
  user: User;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  showBadge?: boolean;
  onClick?: () => void;
  className?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  size = 'md',
  showBadge = true,
  onClick,
  className = ''
}) => {
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const textSizeClasses = {
    xs: 'text-xs',
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  return (
    <div className={`relative ${className}`}>
      <div
        className={`${sizeClasses[size]} rounded-full overflow-hidden transition-transform hover:scale-105 bg-gray-800/40 ${
          onClick ? 'cursor-pointer' : ''
        }`}
        onClick={onClick}
      >
        {user.profilePicture ? (
          <div className="w-full h-full flex items-center justify-center">
            <img
              src={user.profilePicture}
              alt={user.displayName || user.username}
              className="w-full h-full object-cover object-center"
              onError={(e) => {
                // Fallback en cas d'erreur de chargement
                const target = e.target as HTMLImageElement;
                target.src = `https://api.dicebear.com/7.x/avataaars/svg?seed=${user.username || user.id}`;
              }}
            />
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <img
              src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${user.username || user.id}`}
              alt={user.displayName || user.username}
              className="w-full h-full object-contain"
            />
          </div>
        )}
      </div>
      
      {/* Badge de vérification */}
      {showBadge && user.isVerified && (
        <div className="absolute -bottom-0.5 -right-0.5 bg-green-500 rounded-full p-0.5">
          <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      )}
    </div>
  );
};
